import React from "react";
import apiClient from "../common/apiClient";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import InputTextField from "../components/textField/InputTextField";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import "react-datepicker/dist/react-datepicker.css";
import threeImpactSizeGuide from "../images/lowMedHighFootSize.png";
import twoImpactSizeGuide from "../images/standardHighFootSize.png";
import { Table } from "react-bootstrap";
import TextField from '@material-ui/core/TextField';
import ClearOrder from "../components/modal/ClearOrder";
import { ToCamelCase } from '../common/common';

export default class MultipleFootSelection extends OrderFormStep {
  constructor(props) {
    super(props);

    this.carbonFiberID = 284;
    this.highImpactID = 288;

    this.state = {
      isLoading: false,
      isSubmit: false,
      footInterfaces: [],
      footSizes: [],
      footProfiles: [],
      footOptionCombinations: [],
      footCategories: [],
      footSuspensions: [],
      footSides: [],
      formState: {
        currentFeet: [],
        indexedcurrentFeet: [],
        footPartNumber: new FieldState(false, ""),
        footType: new FieldState(false),
        footMaterial: new FieldState(false),
        footImpact: new FieldState(false),
        footShell: new FieldState(false),
        footQuantity: new FieldState(false, 1),
        footCategory: new FieldState(false),
        footSide: new FieldState(false),
        footSize: new FieldState(false),
        selectedfootPartNumber: null,
      },
    };

    this.addfootFromPartNumber = this.addfootFromPartNumber.bind(this);
    this.addfootFromSelection = this.addfootFromSelection.bind(this);
    this.loadCart = this.loadCart.bind(this);
  }

  setServerfootQuantity(partNumber, quantity) {
    let url = `footQuantity/${this.props.formTypeId}`; 
    if (this.props.isMulti) {
      url = `footQuantity/${this.props.formTypeId}?isMulti=${this.props.isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`;
    }

    apiClient.post(
      url,
      {
        partnumber: partNumber,
        quantity: quantity
      }
    ).then(response => {
      if(response.data.success) {
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }

  setLocalfootQuantity(partNumber, quantity) {
    var formState = this.state.formState
    var feet = formState.currentFeet;
    feet = this.state.formState.currentFeet.map((foot) => {
      if(foot.partNumber === partNumber) {
        foot.quantity = quantity;
      }

      return foot;
    });

    formState.currentFeet = feet;
    this.setState({
      formState: formState
    });
  }

  addfootFromPartNumber() {
    var formState = this.state.formState;

    let partNumber = formState.footPartNumber.value;
    let quantity = formState.footQuantity.value;
    partNumber = partNumber.trim();
    
    this.addfootRequest(partNumber, quantity);

    formState.footPartNumber.value = "";
    formState.footQuantity.value = 1;

    this.setState({
      formState: formState
    });
  }

  addfootFromSelection() {
    var formState = this.state.formState;

    let partNumber = formState.selectedfootPartNumber;
    let quantity = formState.footQuantity.value;
    partNumber = partNumber.trim();

    this.addfootRequest(partNumber, quantity);


    formState.footQuantity.value = 1;
    formState.selectedfootPartNumber = null;

    this.setState({
      formState: formState
    });
  }

  addfootRequest(partNumber, quantity) {

    apiClient.post(
      `addfoot/${this.props.formTypeId}?isMulti=${this.props.isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`,
      {
        partnumber: partNumber,
        footTypeId: this.state.formState.footType.value,
        footShellId: this.state.formState.footShell.value,
        footSize: this.state.formState.footSize.value,
        footSide: this.state.formState.footSide.value,
        quantity: quantity
      }
    ).then(response => {
      if(response.data.success) {
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }


  async loadCart() {
    var saveFeet = (cartData) => {
      let feet = cartData.map((item) => {
        if (item === null) {
          return null;
        }

        return {
          name: item.name,
          partNumber: item.partNumber,
          quantity: item.quantity,
          sourceId: item.sourceId
        };
      });

      let cartWithIndex = Object.groupBy(feet, ({ sourceId }) => sourceId);
      const formIndexedCart = Object.values(cartWithIndex);

      var formState = this.state.formState;
      formState.currentFeet = feet;
      formState.indexedCurrentFeet = formIndexedCart;
      this.setState({
        formState: formState
      });
    }
    saveFeet = saveFeet.bind(this);

    let productsAdded = null;
    let isMulti = null;
    let currentBasket = null;
    if (this.props.productsAdded) {
      productsAdded = await this.props.productsAdded()
      isMulti = this.checkIsMulti(productsAdded)
      if (isMulti) {
        currentBasket = await this.props.getProductBasket(this.props.parentFormTypeId);
      }
    }

    let url = `cart/`;
    if (isMulti) {
      url += `${this.props.parentFormTypeId}?isMulti=${isMulti}&basketId=${currentBasket?.id}`
    } else {
      url += `${this.props.formTypeId}`
    }

    await apiClient.get(
      url
    ).then(response => {
      this.props.setTempCart(response.data);
      saveFeet(response.data);
      this.props.loadCart();
    }).catch(error => {
      console.log(error)
    });

    var saveFootPartnumber = (partnumber) => {
      var formState = this.state.formState;
      formState.selectedfootPartNumber = partnumber;

      this.setState({
        formState: formState,
        hasDataChanged: true
      });
    }
    saveFootPartnumber=saveFootPartnumber.bind(this);

    apiClient.post("generateFootPartNumber/" + this.props.formTypeId,
      {
        footTypeId: this.state.formState.footType.value,
        materialId: this.state.formState.footMaterial.value,
        impactId: this.state.formState.footImpact.value,
        sideId: this.state.formState.footSide.value,
        size: this.state.formState.footSize.value,
        category: this.state.formState.footCategory.value,
      }
    ).then(response => {
      saveFootPartnumber(response.data)
    }).catch(error =>{
      console.log(error)
    });
  }

  isRequired() {
    return false;
  }

  updateRequirements() {
    var formState = this.state.formState;
    var required = this.isRequired();

    formState.footType.isRequired = required;
    formState.footMaterial.isRequired = required;
    formState.footImpact.isRequired = required;
    formState.footShell.isRequired = false;

    this.setState({
      formState: formState
    });
  }

  onInputChange(e, id) {
    let formState = this.state.formState;
    formState.footQuantity.value = e.target.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });
  }

  componentDidMount() {
    this.loadData();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.updateCartEditor !== this.props.updateCartEditor) {
      let formState = this.state.formState;
      formState.currentFeet = [];
      this.setState({ formState: formState });
      this.props.setUpdateCartEditor(false)
    }
  }

  async loadData() {
      this.setState({
        footTypes: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footType" },
            }
          )
        ).data,
        footSides: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footDirection" },
            }
          )
        ).data,
        addFootOptions: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "includeFoot" },
            }
          )
        ).data,
        footShells: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footShell" },
            }
          )
        ).data,
        footMaterials: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footMaterial" },
            }
          )
        ).data,
        impactLevels: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footImpact" },
            }
          )
        ).data,
      });

       let footData = await apiClient.get(
        `foot/${this.props.formTypeId}?isMulti=${this.props.isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`
      );

      this.setState({
        footOptionCombinations: footData.data.options,
        footCategories: footData.data.categories
      });

    await this.loadCart();
    this.setState({ isLoaded: true });
  }

  saveData() {
    let totalNoOfFeet = 0;
    if (this.state.formState.currentFeet) {
      this.state.formState.currentFeet.filter(cf => cf.sourceId === 'foot').forEach(f => {
        totalNoOfFeet += parseInt(f.quantity);
      })
    }
    
    if (totalNoOfFeet === 0) {
      CreateNotification("Cannot place Foot Order with no items.", "error");
      return null;
    }


    let data = [];

    return apiClient.post(
      `fieldInputs/${this.props.formTypeId}?isMulti=${this.props.isMulti}&parentFormTypeId=${this.props.parentFormTypeId}`,
      data
    );
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  generateOptionsForRange(min,max) {
    return Array(max-min + 1).fill(0).map((_, i) => {return {id: i+min, displayName: i+min}});
  }
  
  resetForm() {
    if (this.props.resetForm) {
      let formState = this.state.formState
      formState.currentFeet = [];
      formState.footPartNumber.value = "";
      formState.footType.value = "";
      formState.footMaterial.value = "";
      formState.footImpact.value = "";
      formState.footShell.value = "";
      formState.footQuantity.value = 1;
      formState.footCategory.value = "";
      formState.footSide.value = "";
      formState.footSize.value = "";
      formState.selectedfootPartNumber = null;
      this.setState({ formState: formState })
      this.props.setResetForm(false)
    }
  }

  async saveIds(addedFormTypeIDs) {
    addedFormTypeIDs = addedFormTypeIDs.filter(p => p !== "");
    const formTypeIdsToAddJson = addedFormTypeIDs.toString();

    let data = [];
    data.push({
      fieldName: "addedFormTypeIDs",
      stringData: formTypeIdsToAddJson,
    });

    return await apiClient.post(
      "fieldInputs/" + this.props.parentFormTypeId,
      data
    )
  }

  async removeProduct(name) {
    try {
      const formData = await this.props.getFormData();
      const fd = formData.find(f => f.name === name);
      let idToRemove = fd.formContent.props.formTypeId;
      const currentAddedFormTypeIDs = await this.props.productsAdded();
      let addedFormTypeIDs = currentAddedFormTypeIDs.split(",").filter(id => id !== '');
      addedFormTypeIDs = addedFormTypeIDs.filter(i => parseInt(i) !== idToRemove);
      this.props.setFormTypeIdsToAdd(addedFormTypeIDs);
      await this.props.removeProduct(fd);
      await this.saveIds(addedFormTypeIDs);
      this.props.loadCart();
      this.props.getFormData();
    } catch (ex) {
      this.setState({
        isLoading: false
      });
      console.log(ex);
    }
  }

  checkIsMulti(productsAdded) {
    return (productsAdded && productsAdded !== '') ? true : null
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    if (this.props.resetForm) {
      this.resetForm();
    }

    let validFootTypes = this.state.footTypes.filter(ft => {
      return this.state.footOptionCombinations.some(c => c.footTypeId === ft.id)
    }
    );

    let currentType = this.state.formState.footType.value;
    let validMaterials = this.state.footMaterials.filter(m =>
      this.state.footOptionCombinations.some(c => c.footTypeId === currentType 
                                          && c.materialId === m.id)
    );

    let currentMaterial = this.state.formState.footMaterial.value;

    let validImpacts = this.state.impactLevels.filter(m =>
      this.state.footOptionCombinations.some(c => c.footTypeId === currentType 
            && c.materialId === currentMaterial
            && c.impactId === m.id)
    );

    let image=null;
    if(validImpacts?.length === 2) {
      image=twoImpactSizeGuide;
    } else if(validImpacts?.length === 3) {
      image=threeImpactSizeGuide;
    }

    let currentImpact = this.state.formState.footImpact.value;
    let validCategories = [];
    if(currentImpact === this.highImpactID && validImpacts?.length === 3) {
      validCategories = this.generateOptionsForRange(2,9);
    } else if(currentImpact) {
      validCategories = this.generateOptionsForRange(1,9);
    }

    let currentCategory = this.state.formState.footCategory.value;
    let validSizes = [];
    if(currentCategory && currentCategory <= 5) {
      validSizes = this.generateOptionsForRange(22,30);
    } else if(currentCategory) {
      validSizes = this.generateOptionsForRange(25,30);
    }

    let currentSize = this.state.formState.footSize.value;

    let partnumber = this.state.formState.selectedfootPartNumber;

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => { e.preventDefault() }}>

          <div className="fieldBorder">
            <div className="msgBox fieldBorder msgBoxWidth">
              <h4 className="headLable"><b>Quick Entry:</b></h4>
              <br />
              <p>Use this section to add any WillowWood foot to your order (including SACH, DuraWalk, META, etc). Enter the Part Number (including hyphens), update Quantity desired and Click "Add" to populate the item to your Cart.</p>  
              <p className='red-emphasis'>Remember to also add the Foot Shell Part Number.</p>
              <p className="font-italic text-secondary">Example Foot Part Number M006-26R-4L.</p>
              <p className="font-italic text-secondary">Example Foot Shell Part Number FS01-26RB.</p>
            </div>
              <div className="fieldWrapper" style={{ paddingTop: '10px'}}>
                  <InputTextField
                    label="Part Number"
                    variant="outlined"
                    placeholder=""
                    type="text"
                    width="384px"
                    required={false}
                    value={this.state.formState.footPartNumber.value}
                    onChange={(e) => {
                      let formstate = this.state.formState;
                      formstate.footPartNumber.value = e.target.value.toUpperCase();
                      this.setState({ formState: formstate });
                    }}
                  />
                  <InputTextField
                    label="Quantity"
                    variant="outlined"
                    placeholder=""
                    type="number"
                    width="384px"
                    required={false}
                    value={this.state.formState.footQuantity.value}
                    onChange={this.onInputChange}
                  />
                  <div style={{ paddingTop: '20px'}}>
                    <SecondaryButton
                      text="Add"
                      onClick={this.addfootFromPartNumber}
                    />
                  </div>
              </div>
            </div>

            <br />

          <div className="msgBox fieldBorder msgBoxWidth">
            <h4 className="headLable"><b>Foot Part Number Wizard</b></h4>
            <br />
            <p>Use the guided wizard to build your META Foot Part Number and corresponding Foot Shell Part Number. Update Quantity desired and “Add” to Cart.</p>
          </div>
              <div className="fieldBorder">
                <MuiRadio
                  options={validFootTypes}
                  defaultValue={currentType}
                  label="Foot Type"
                  required={this.state.formState["footType"].isRequired}
                  error={this.handleError("footType") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footType");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validMaterials}
                  defaultValue={currentMaterial}
                  label="Material"
                  required={this.state.formState["footMaterial"].isRequired}
                  error={this.handleError("footMaterial") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footMaterial");
                  }}
                />
              </div>

              {image && <img src={image} width="600" alt="Size Guide" />}

              <div className="fieldBorder">
                <MuiRadio
                  options={validImpacts}
                  defaultValue={currentImpact}
                  label="Impact"
                  required={this.state.formState["footImpact"].isRequired}
                  error={this.handleError("footImpact") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footImpact");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validCategories}
                  defaultValue={currentCategory}
                  label="Category"
                  required={this.state.formState["footCategory"].isRequired}
                  error={this.handleError("footCategory") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footCategory");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validSizes}
                  defaultValue={currentSize}
                  label="Size"
                  required={this.state.formState["footSize"].isRequired}
                  error={this.handleError("footSize") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footSize");
                  }}
                />
              </div>

              <div className="fieldBorder">
              <MuiRadio
                options={this.state.footSides}
                label="Side"
                required={this.state.formState.footSide.isRequired}
                defaultValue={this.state.formState.footSide.value}
                error={this.handleError("footSide") && this.state.isSubmit}
                onChange={(e) => {
                  this.onRadioChange(e, "footSide");
                }}
              />
            </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={this.state.footShells}
                  defaultValue={this.state.formState.footShell.value}
                  label="Foot Shell"
                  required={this.state.formState["footShell"].isRequired}
                  error={this.handleError("footShell") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footShell");
                  }}
                />
              </div>


              <div className="fieldWrapper" style={{ paddingTop: '10px'}}>
                  <InputTextField
                    label="Selected Part Number"
                    variant="outlined"
                    placeholder=""
                    type="text"
                    width="384px"
                    required={false}
                    disabled
                    value={partnumber}
                    
                  />
                  <InputTextField
                    label="Quantity"
                    variant="outlined"
                    placeholder=""
                    type="number"
                    width="384px"
                    required={false}
                    value={this.state.formState.footQuantity.value}
                    onChange={this.onInputChange}
                  />
                  <div style={{ paddingTop: '20px'}}>
                  <SecondaryButton
                    text="Add"
                    onClick={this.addfootFromSelection}
                  />
                  </div>
              </div>
              {this.state.formState.currentFeet.length > 0 && 
                <div className="fieldBorder">
                  <br />
                  <div className="msgBox msgBoxWidth">
                    <h4 className="headLable"><b>{`Current ${this.props.isMulti ? 'Products' : 'Feet'} in Cart`}</b></h4>
                  </div>
                  <br />
                <Table className="transparent-table">
                  <thead>
                    <tr>
                      <th><b>{`${this.props.isMulti ? 'Product' : 'Foot'}`}</b></th>
                      <th></th>
                      <th><b>Part Number</b></th>
                      <th><b>Quantity</b></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.formState.indexedCurrentFeet.map((indexedFoot, index) => {
                      return (
                        <React.Fragment key={index}>
                          {this.props.isMulti && <tr className="th-border" colSpan={5}><td className="th-padding"><div><b>{ToCamelCase(indexedFoot[0].sourceId)}</b></div></td></tr>}
                          {indexedFoot.map((foot, index) => {
                            if (foot === null) {
                              return "";
                            }
                            return (
                              <tr key={`${foot.partNumber}_${index}`}>
                                <td lg="6" sm="1">
                                  <div>{foot.name}</div>
                                </td>
                                <td></td>
                                <td>
                                  <div>{foot.partNumber}</div>
                                </td>
                                <td>
                                  <TextField
                                    type={"number"}
                                    onChange={(e) => {
                                      if (foot.sourceId !== 'foot') {
                                        CreateNotification("Can only adjust quantity of Foot products from this page.", "error");
                                      } else {
                                        this.setLocalfootQuantity(foot.partNumber, e.target.value);
                                      }
                                    }}
                                    onBlur={() => {
                                      if (foot.sourceId === 'foot') {
                                        this.setServerfootQuantity(foot.partNumber, foot.quantity);
                                      }
                                    }}
                                    value={foot.quantity}
                                  />
                                </td>
                                <td><SecondaryButton
                                  text="Remove"
                                  onClick={() => {
                                    if (foot.sourceId !== 'foot') {
                                      CreateNotification("Can only remove Foot products from this page.", "error");
                                    } else {
                                      this.setServerfootQuantity(foot.partNumber, 0)
                                    }
                                  }}
                                />
                                </td>
                              </tr>
                            )
                          })}
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </Table>
                </div>
              }
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text="Clear the Order?"
            onClick={this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            {this.props.isMulti ?
              <SecondaryButton
                text={`Remove this Form`}
                onClick={async () => {
                  this.setState({
                    isLoading: true
                  })
                  await this.removeProduct("Feet");
                }}
                disabled={this.state.isLoading}
              />
              : <></>}
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack()}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext();
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId={this.props?.isMulti ? this.props.parentFormTypeId : this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
          isMulti={this.props.isMulti}
        />
      </>
    );
  }
}